import { initialState } from "./state"
import { withLogo } from "@/common/helpers/itemWithLogo.helper"

export const setPodcasts = (state, payload) => {
  state.podcasts = payload === null ? null : payload.map(withLogo)
}

export const setPodcast = (state, payload) => {
  state.podcast = withLogo(payload)
}

export const resetPodcast = (state) => {
  state.podcast = initialState().podcast
  state.availability = null
}

export const setAvailability = (state, payload) => {
  state.availability = payload
}

export const reset = (state) => {
  const s = initialState()
  Object.keys(s).forEach((key) => {
    state[key] = s[key]
  })
}
